import {
  ExperimentName,
  TrackingEventName
} from 'shared/experiments/consts/types'
import {
  RELEASE_SWITCH_TOGGLE,
  RELEASE_TOGGLE_ERX,
  RELEASE_TOGGLE_ERX_ANNOUNCEMENT,
  RELEASE_TOGGLE_MARKETPLACE,
  RELEASE_TOGGLE_SAE_ONLY
} from 'shared/experiments/consts/names'
import { Experiment } from 'server/shop-config/types'

const MAX_LENGTH = 64
const RE_VALID_NAME = /^[\w\d_\s-.]+$/i

/**
 * Validation requirements and error message are copied from Optimizely dashboard.
 *
 * @example event`MY OPTIMIZELY EVENT`
 * @throws if event name is invalid
 */
export const event = (
  strings: TemplateStringsArray,
  ...vars: string[] | TrackingEventName[]
): TrackingEventName => {
  // eslint-disable-next-line max-params
  const chunks = strings.reduce((acc: string[], cur: string, index: number) => {
    return acc.concat(`${cur}${vars[index] ?? ''}`)
  }, [])

  const name = chunks.join('')
  if (name.length <= MAX_LENGTH && RE_VALID_NAME.test(name)) {
    return name as unknown as TrackingEventName
  }

  throw Error(
    `"${name}" event must be no longer than 64 characters and consist of only alphanumeric characters, hyphens, underscores, spaces, and periods`
  )
}

// TODO find out why the names are duplicated in `app/views/utils/experiments/helpers.ts`

// eslint-disable-next-line max-params
export function isExperimentVariableTrue(
  key: ExperimentName,
  variable: string,
  experiments: Experiment[] = []
): boolean {
  const experiment = experiments.find(e => e.name === key)
  if (!experiment?.isEnabled) {
    return false
  }

  return experiment?.variables?.[variable] === true
}

export const isSaeOnly = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_SAE_ONLY,
    experiments
  )

export const isMarketplace = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_MARKETPLACE,
    experiments
  )

export const isERx = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_ERX,
    experiments
  )

export const isERxAnnouncement = (experiments: Experiment[] = []): boolean =>
  isExperimentVariableTrue(
    RELEASE_SWITCH_TOGGLE,
    RELEASE_TOGGLE_ERX_ANNOUNCEMENT,
    experiments
  )
